module.exports = __webpack_public_path__ + "img/0015.7d82f446.jpg";